import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconThumbsUpStyle0 = cosmosIconCss;

const CosmosIconThumbsUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconThumbsUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bf53202ed745c613881920aab1876cd7b91eb78b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e77ff7aca90123f02cbbd15ec97da111e0f88225', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'eee54f6c9d4889f656a9187ef91950a71078c29e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 17c.173 0 .337-.08.44-.22 1.33-1.93 2.06-3.14 2.06-5.62a8.996 8.996 0 0 0-.33-2.56.492.492 0 0 0-.47-.36c-.264 0-1.424.126-2.53.246-.571.063-1.128.123-1.54.164.222-.864.382-1.743.48-2.63 0-1.32-.88-2.01-2.56-2.01-.86 0-1.15.07-1.28.43l-2.14 5.71a1.742 1.742 0 0 0-.13.75v4.35a.465.465 0 0 0 .18.38c1.491 1.281 3.55 1.31 7.293 1.362L15.5 17Zm-.5-1.5c-3.96 0-5.08-.18-6-.75v-3.97l1.96-5.27c.85 0 1.15.05 1.15.51 0 .317-.202 1.254-.518 2.722l-.202.938a.477.477 0 0 0 .54.6l4.48-.45c.061.44.092.885.09 1.33A6.648 6.648 0 0 1 15 15.5ZM3.5 9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-2Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconThumbsUpStyle0; }
}, [1, "cosmos-icon-thumbs-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-thumbs-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-thumbs-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconThumbsUp$1);
            }
            break;
    } });
}

const CosmosIconThumbsUp = CosmosIconThumbsUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconThumbsUp, defineCustomElement };
